import { FeatureState } from '../models'

import { FeatureActionTypes } from './actionTypes'

export default class FeatureActions {
  static getFeaturesSuccess(features: FeatureState['features']) {
    return {
      type: FeatureActionTypes.GET_FEATURES_SUCCESS,
      payload: features
    }
  }

  static getFeaturesError(error) {
    return {
      type: FeatureActionTypes.GET_FEATURES_ERROR,
      payload: error
    }
  }

  static getFeatures() {
    return {
      type: FeatureActionTypes.GET_FEATURES
    }
  }
}
